import * as L from 'leaflet';

export function getUndoControlOptions(afterClick: () => void): L.PM.CustomControlOptions & { disableByOtherButtons: boolean } {
  return {
    name: 'undo',
    block: 'custom',
    title: 'Undo',
    afterClick,
    toggle: false,
    disableByOtherButtons: false
  };
}
